import React, { PureComponent } from 'react';
import SliderLetters from '../../componets/slider';

class Home extends PureComponent {
  render() {
    return (
      <section className="home-slider">
        <SliderLetters/>
      </section>
    )
  }
}

export default Home;